import {Component} from '@angular/core';
import {AlertController, NavParams, ViewController} from 'ionic-angular';

import {ContratosGestaoService} from '../../../providers/contratos-gestao-service';
import {AlertService} from '../../../providers/alert-service';

@Component({
    selector: 'page-modal-pessoa-rol',
    templateUrl: 'modal-pessoa-rol.html',
    providers: [
        ContratosGestaoService
    ]
})
export class ModalPessoaRolPage {
    cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    emailMask = [/\^[A-Za-z0-9._%+-]\+/, '@', /[A-Za-z0-9.-]\+/, '.', /[A-Za-z]\{2,4}\$/];
  
    pessoaGrupoAtual: any;
    loading: boolean = true;
    cdModulo: any;
    titulo: any;
    objetoRetorno: {
        flag: boolean,
        objeto: string
    };
    jurisdicionado: any;
    pageListaContratos: number = 1;
    dados: any;
    contratos: any = [];

    order: string = 'nmContrato';
    reverse: boolean = false;

    constructor(public alertCtrl: AlertController,
        private alertService: AlertService,
        private viewCtrl: ViewController,
        public navParams: NavParams,
        public contratosGestaoService: ContratosGestaoService) {

        this.objetoRetorno = {
            flag: false,
            objeto: ""
        };
        this.pessoaGrupoAtual = this.navParams.get('dados');
        console.log(this.pessoaGrupoAtual);
        this.titulo = this.navParams.get('param1');
        this.dados = this.navParams.get('dados');

        // this.carregarDados();

        this.loading = false;
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }

        this.order = value;
    }

    //  carregarDados() {

    //      let count = 0;

    //      this.contratosGestaoService.forEach(contrato => {
    //          this.contratosGestaoService.obterPorNumeroContrato(contrato).subscribe(data => {
    //              //this.contratoService.obterPorNumeroContrato(contrato).toPromise().then(data => {
    //              if (data != null && data != undefined) {
    //                  this.contratos.push(data);
    //              }
    //          }, error => {
    //              console.log("erro: " + error);
    //          });
    //      });

    //      setTimeout(() => {
    //          this.loading = false;
    //      }, 15000);
    //  }

     showTimeout() {
         this.loading = false;
     }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
      }

    dismiss() {
        this.objetoRetorno.flag = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 20;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 20;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }
}




// WEBPACK FOOTER //
// ./src/pages/modais/modal-pessoa-rol/modal-pessoa-rol.ts